const BORDER_RADIUS = '0.5rem';

export default BORDER_RADIUS;
